import React from "react";
import QuestionStats from "./questionStats";

const QuestionsList = ({ uuids, updateUuid, activeUuid }) => {
    return (
        <>
            <div className="questions-list-container">
                <QuestionStats label={"All Questions"} isActive={!activeUuid} uuid={''} updateUuid={updateUuid}/>
                {
                    uuids.map(object => {
                        let key = object.uuid;

                        return <QuestionStats isActive={activeUuid === key} key={key} uuid={key} label={object.label} updateUuid={updateUuid}/>
                    })
                }                
            </div>
        </>
    );
}

export default QuestionsList;